import { Component } from '@angular/core';

@Component({
  selector: 'app-justlivetutors',
  templateUrl: './justlivetutors.component.html',
  styleUrls: ['./justlivetutors.component.scss']
})
export class JustlivetutorsComponent {

}
